import React from 'react';

import { ReactComponent as CompanyLogoFullIcon } from '../../../../assets/CompanyLogoFull.svg';
import { ReactComponent as CompanyLogoFullLightIcon } from '../../../../assets/logo/CompanyLogoFullLight.svg';
import { ReactComponent as CompanyLoginIcon } from '../../../../assets/loginArt//Onboarding/loginLogo.svg';
import { ReactComponent as MagnifyingGlassIcon } from '../../../../assets/loginArt/Onboarding/greenSearchIcon.svg';


import {
  SvgIcon,
  SvgIconProps
} from '@mui/material';

export type CustomIconProps = {
  icon: IconTypes;
};

export type IconTypes =
  'COMPANYLOGOFULL' |
  'COMPANYLOGIN' |
  'COMPANYLOGOFULLLIGHT' |
  'MAGNIFYINGGLASS';



export const __icon2iconUrl: Record<IconTypes, React.ReactElement> = {

  COMPANYLOGOFULL: <CompanyLogoFullIcon />,
  COMPANYLOGOFULLLIGHT: <CompanyLogoFullLightIcon />,
  COMPANYLOGIN: <CompanyLoginIcon />,
  MAGNIFYINGGLASS: <MagnifyingGlassIcon />
};

export const FC = (props: CustomIconProps & SvgIconProps) => {
  const Res = __icon2iconUrl[props.icon];

  return (

    <Res.type {...props} />

  );
};
